import Config from '../../../commons/config/Config.js'
import ConfigBusiness from '../../../commons/config/ConfigBusiness.js'

// VEC-3990: helpers del control de odómetro en el alta de checklist.

const TOLERANCIA_DEFAULT = 1000

// Tolerancia de diferencia de medidor (moviles.editaKm.maximo); 1000 si no es numérica.
export function getToleranciaOdometro() {
  const raw = ConfigBusiness.get('moviles.editaKm.maximo')
  if (raw === null || raw === undefined || raw === '' || typeof raw === 'boolean') return TOLERANCIA_DEFAULT
  const valor = Number(raw)
  return isFinite(valor) ? valor : TOLERANCIA_DEFAULT
}

// Bloqueo por tolerancia activo solo si la config vale 'true'.
export function isControlOdometroHabilitado() {
  return ConfigBusiness.get('checklist.movil.actualizaOdometroLimitado.habilitado') === 'true'
}

// Igual a la tolerancia NO supera.
export function superaTolerancia(valor, kmActual, tolerancia) {
  return Math.abs(valor - kmActual) > tolerancia
}

// Proyección de las llantas del móvil si el odómetro pasa a `km`.
// Usa fetch directo y no AjaxHandler: el preview es informativo, así que ante cualquier error
// (401/403/500 o red) solo rechaza, sin el modal global de AjaxHandler. El backend valida igual al guardar.
export function fetchProyeccionOdometro(movilId, km) {
  const url = Config.get('apiUrlBase') + '/moviles/' + movilId + '/llantas/proyeccion-odometro?km=' + encodeURIComponent(km)
  return fetch(url, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Authorization-Token': localStorage.getItem('token')
    }
  }).then(response => {
    if (!response.ok) throw new Error('proyeccion-odometro: HTTP ' + response.status)
    return response.json()
  })
}
